import TableColumn from '@models/table-column';

export const COLUMN_TABLE_REPARTITION_TOP_UPS: TableColumn[] = [
  {
    name: 'ESTABLISHMENT',
    orderable: true,
    sortingField: 'topUps.establishmentId',
  },
  {
    name: 'CREDIT',
    orderable: false,
    sortingField: '',
  },
  {
    name: 'THRESHOLD',
    orderable: true,
    sortingField: '',
  },
];
